/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetExamPeriods: {
        $xmlns: 'http://dobs.pa.gov/nd/exam/bpm/1.0'
      }
    },
    blueprintArrays: ['GetExamPeriodsResponse.ND_ExamPeriod'],
    blueprint: {
      examPeriod: [
        '$..ND_ExamPeriod',
        {
          id: '$.ID',
          yearPeriod: '$.YearPeriod',
          createdDate: '$.CreatedDate',
          startDate: '$.StartDate',
          endDate: '$.EndDate'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      _.each(response.examPeriod, function(examPeriod) {
        examPeriod.startDate = moment(examPeriod.startDate, 'YYYY-MM-DD');
        examPeriod.endDate = moment(examPeriod.endDate, 'YYYY-MM-DD');
      });
      defer.resolve(response.examPeriod);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
